const calculateHomeQuery = `mutation (
    $request: HomeContentPackageSchema_MasterAgreementStructureInput!
) {
    calculateHomeContentPackageV2(
        input: {
            input: $request
        }
    ) {
        homeContentPackageSchema_MasterAgreementStructure {
            masterAgreementPackages {
                objectBuildings {
                    constructionYear
                    homeType
                    propertyOfInsured
                    outbuildingsPresent
                }
                policyPolicyDetails {
                    coverageBuildings {
                        clauses {
                            clauseExplanation
                            clauseName
                            clauseNumber
                        }
                        documents {
                            attachmentDescription
                            attachmentType
                            urlAttachment
                        }
                        conditionConditionDetails {
                            documents {
                                attachmentDescription
                                attachmentType
                                urlAttachment
                            }
                            conditionNumber
                            conditionText
                        }
                        refKey
                        sumInsured
                        totalInstallmentAmount
                        deductibleAmount
                        costsInstallmentAmount
                        discountsInstallmentAmount
                        grossPremiumInstallment
                        insuranceTaxInstallmentAmount
                        surchargesInstallmentAmount
                        deductibleDescription
                        netPremiumInstallment
                        effectiveDate
                        productDescription
                    }
                    coverageHomes {
                        clauses {
                            clauseExplanation
                            clauseName
                            clauseNumber
                        }
                        documents {
                            attachmentDescription
                            attachmentType
                            urlAttachment
                        }
                        conditionConditionDetails {
                            documents {
                                attachmentDescription
                                attachmentType
                                urlAttachment
                            }
                            conditionNumber
                            conditionText
                        }
                        refKey
                        sumInsured
                        totalInstallmentAmount
                        deductibleAmount
                        costsInstallmentAmount
                        discountsInstallmentAmount
                        grossPremiumInstallment
                        insuranceTaxInstallmentAmount
                        surchargesInstallmentAmount
                        deductibleDescription
                        netPremiumInstallment
                        effectiveDate
                        productDescription
                        insuredAmountTenantInterest
                        insuredAmountMusicalInstruments
                        insuredAmountCollections
                        insuredAmountComputerEquipment
                        insuredAmountValuablesOutdoors
                        insuredAmountJewelry
                        insuredAmountOther
                        insuredAmountAudioVideoComputerEquipment
                        insuredAmountOtherValuables
                        customProperties {
                            insuredAmountAudioVideo
                            insuredAmountAntiques
                            insuredAmountArt
                            infofolioSumInsured
                        }
                    }
                    coverageLiabilities {
                        clauses {
                            clauseExplanation
                            clauseName
                            clauseNumber
                        }
                        documents {
                            attachmentDescription
                            attachmentType
                            urlAttachment
                        }
                        conditionConditionDetails {
                            documents {
                                attachmentDescription
                                attachmentType
                                urlAttachment
                            }
                            conditionNumber
                            conditionText
                        }
                        refKey
                        sumInsured
                        totalInstallmentAmount
                        deductibleAmount
                        costsInstallmentAmount
                        discountsInstallmentAmount
                        grossPremiumInstallment
                        insuranceTaxInstallmentAmount
                        surchargesInstallmentAmount
                        netPremiumInstallment
                        effectiveDate
                        productDescription
                        deductibleAmountDamageByChildren
                    }
                    paymentTermInMonths
                    refKey
                    productCode
                    productDescription
                    companyNameDescription
                    marketingName
                    porCompany
                    expectedAcquisitionCommissionPartnerAmount
                }
                underwritingCompanySpecifics {
                    rejectionReason
                    underwritingResult
                }
                effectiveDate
                porCompany
                productCode
                productDescription
                companyNameDescription
                costsInstallmentAmount
                grossPremiumInstallment
                insuranceTaxInstallmentAmount
                insuranceTaxPercentage
                netPremiumInstallment
                netPremiumInstallmentExcludingPackageDiscount
                numberOfSubPolicies
                packageDiscountInstallmentAmount
                packageDiscountPercentage
                paymentTermInMonths
                returnCommissionPercentage
                surchargesInstallmentAmount
                totalInstallmentAmount
                installmentAmountRenewalCharges
                oneOffCostsAmount
                externalSourceName
                orderFormId
                expectedAcquisitionCommissionPartnerAmount
                customProperties {
                    supplierKrn
                    supplierExternalProductCategory
                    buildingHomeCombinationTotalInstallmentAmount
                }
            }
            commonTechnical {
                accessCode
                transactionReference
            }
        }
        errors {
            ... on HomeContentPackageSchema_IGraphQlErrorBase {
                type
                message
            }
        }
    }
}
`;

export default calculateHomeQuery;
